
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/limited-time-launch-promo",
      function () {
        return require("private-next-pages/limited-time-launch-promo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/limited-time-launch-promo"])
      });
    }
  